import React, { useEffect, useState } from 'react';
import { AppGridSkeleton, AppGrid } from '@wix/app-market-components';
import { getSitesPremiumStatus } from '@wix/ambassador-premium-v1-asset/http';
export const AppsGridWidget = _ref => {
  let {
    data: {
      apps,
      metaSiteId
    },
    context: {
      webActions,
      httpClient
    }
  } = _ref;
  const [isPremiumSite, setIsPremiumSite] = useState(null);
  useEffect(() => {
    httpClient == null || httpClient.request(getSitesPremiumStatus({
      metaSiteIds: [metaSiteId]
    })).then(_ref2 => {
      let {
        data: {
          sitesPremiumStatus
        }
      } = _ref2;
      const sitePremiumStatus = sitesPremiumStatus == null ? void 0 : sitesPremiumStatus.find(site => site.metaSiteId === metaSiteId);
      setIsPremiumSite((sitePremiumStatus == null ? void 0 : sitePremiumStatus.premiumStatus) === 'PREMIUM' ?? false);
    });
  }, [httpClient, metaSiteId]);
  const handleAppClick = app => {
    if (!(webActions != null && webActions.bmOpenModal)) {
      console.error('[AppsGridWidget] Error: webActions.bmOpenModal is undefined');
      return;
    }
    webActions.bmOpenModal({
      componentId: 'e775acaa-9457-4f7d-839f-a73f1b635f5d',
      componentParams: {
        appId: app.id,
        origin: 'ai-assistant'
      }
    });
  };
  if (isPremiumSite === null) {
    return /*#__PURE__*/React.createElement(AppGridSkeleton, {
      boxCount: 3,
      columns: 1
    });
  }
  return /*#__PURE__*/React.createElement(AppGrid, {
    apps: apps,
    onAppClick: handleAppClick,
    columns: 1,
    isPremiumSite: isPremiumSite === true
  });
};
export const APP_GRID_WIDGET = 'APP_GRID_WIDGET';
//# sourceMappingURL=AppsGridWidget.js.map